import { render, staticRenderFns } from "./paymentMethods.vue?vue&type=template&id=38024dfa"
import script from "./paymentMethods.vue?vue&type=script&lang=js"
export * from "./paymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports